// Only the emblem image stays as a static asset. All other content is dynamic (see content.jsx).
import emblem from "./assets/logo-emblem.png";
export const LOGO = emblem;
